import { render } from "./generalTable.vue?vue&type=template&id=1ad17b22&scoped=true"
import script from "./generalTable.vue?vue&type=script&lang=js"
export * from "./generalTable.vue?vue&type=script&lang=js"

import "./generalTable.vue?vue&type=style&index=0&id=1ad17b22&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\taxes-calculator\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ad17b22"]])

export default __exports__